module.exports = __webpack_public_path__ + "static/media/mcon-poap.f09383e6.png";